import { FormattedMessage, useIntl } from 'react-intl';

import { ContentContainer } from '~/eds/src/components/ContentContainer/ContentContainer';
import { Text } from '~/eds/src/components/Text/Text';
import { PageLayout } from '~/eds/src/modules/PageLayout/PageLayout';

const Page = () => {
  const intl = useIntl();

  const welcome = {
    content: (
      <div>
        <ContentContainer
          placeholderContent={{
            image: 'error-page-access',
            title: intl.formatMessage({
              id: 'WordOnlineInvalidSubscription.errorTitle',
              defaultMessage: 'Invalid Office 365 subscription',
              description: 'Error title for invalid Office 365 subscription',
            }),
          }}
        ></ContentContainer>

        <Text>
          {intl.formatMessage({
            id: 'WordOnlineInvalidSubscription.pageDescription1',
            defaultMessage:
              'Microsoft requires you to have an Office 365 subscription to use Word for the web.',
            description: 'Instructions for Office 365 subscription issues',
          })}
          <br />
          {intl.formatMessage({
            id: 'WordOnlineInvalidSubscription.pageDescription2',
            defaultMessage:
              'If you have a valid Office 365 subscription, try the following: ',
            description:
              'Instructions for troubleshooting Office 365 subscription issues',
          })}
          <br />
          <br />
          <FormattedMessage
            id="WordOnlineInvalidSubscription.pageDescription3"
            defaultMessage="1. Clear your browser's cache."
            description="Instructions for troubleshooting Office 365 subscription issues with specific steps"
          />
          <br />
          <br />
          <FormattedMessage
            id="WordOnlineInvalidSubscription.pageDescription4"
            defaultMessage="2. Open a new browser tab and go to <link>https://office.com</link>. Confirm that you can sign in in and use Word for the Web from your subscription."
            description="Instructions for troubleshooting Office 365 subscription issues with specific steps"
            values={{
              link: (chunks: React.ReactNode) => (
                <a
                  href="https://office.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {chunks}
                </a>
              ),
            }}
          />
          <br />
          <br />
          {intl.formatMessage({
            id: 'WordOnlineInvalidSubscription.pageDescription5',
            defaultMessage:
              '3. Try to edit from Evisort again. If you get prompted for credentials, make sure to use the same credentials you did when signing in to office.com.',
            description:
              'Instructions for troubleshooting Office 365 subscription issues with specific steps',
          })}
        </Text>
      </div>
    ),
  };

  return <PageLayout title="" welcome={welcome} />;
};

export default Page;
